import { wrapWc } from 'brinejs/wrapper'
import '@ica-azure/ica-elements/IcaCard'

type IcaCardProps = React.JSX.IntrinsicElements['tgdb-ica-card']

export const IcaCard = wrapWc<IcaCardProps>('tgdb-ica-card', [])